import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "contact",
  "use": "contact-usage",
  "viewBox": "0 0 26.6 26.6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26.6 26.6\" id=\"contact\"><path d=\"M13.3 26.6C6 26.6 0 20.6 0 13.3 0 6 6 0 13.3 0c7.3 0 13.3 6 13.3 13.3 0 2.7-.8 5.2-2.3 7.4l1.7 5.2-5-1.7c-2.3 1.6-4.9 2.4-7.7 2.4zm0-25.5C6.6 1.1 1.1 6.6 1.1 13.3s5.5 12.2 12.2 12.2c2.6 0 5.1-.8 7.2-2.4l.2-.2 3.5 1.2-1.2-3.6.2-.2c1.4-2.1 2.2-4.5 2.2-7C25.5 6.6 20 1.1 13.3 1.1z\" /><path d=\"M12.4 6h1.4v1.9h-1.4M12.4 10.4h1.3v11.2h-1.3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol